export enum ViewportType {
  SMALL = 556,
  MEDIUM = 761,
  TABLET = 940,
  LARGE = 1271,
  EXTRA_LARGE = 1920,
}
